import React, { useEffect } from "react";
import { Pagination, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchasesModel } from "../purchasesModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IPurchaseDetail } from "../purchasesTypes";
import { formatNum, momentFormat } from "@/utils/utils";
import moment from 'moment';


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, loading
    } = usePurchasesModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])


    const columns: ColumnsType<IPurchaseDetail> = [
        {
            title: '序号',
            width: 45,
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '采购合同号',
            width: 160,
            dataIndex: 'purchaseCode',
            fixed: "left",
        }, {
            title: '状态',
            width: 120,
            dataIndex: 'status',
            fixed: "left",
            render: text => getTreeNodeName(text)
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierName',
            render: text => <p className="ellipsis" title={text}>{text}</p>
        }, {
            title: '商品类别',
            width: 120,
            dataIndex: "typeNum"
        }, {
            title: '总金额',
            width: 120,
            dataIndex: "amountTotal",
            render: (text: any) => `￥${formatNum(text)}`,
        }, {
            title: '签约日期',
            width: 180,
            dataIndex: 'signingTime',
            render: v => momentFormat(v as string, "YYYY-MM-DD")
        }, {
            title: '交货日期',
            width: 180,
            dataIndex: 'exWarehouseTime',
            render: v => momentFormat(v as string, "YYYY-MM-DD")
        }, {
            title: '结算日期',
            width: 180,
            dataIndex: 'settlementTime',
            render: v => momentFormat(v as string, "YYYY-MM-DD")
        }, {
            title: '支付状态',
            width: 100,
            dataIndex: 'payStatus',
            render: text => getTreeNodeName(text)
        },
        // {
        //     title: '结款日期',
        //     width: 180,
        //     dataIndex: 'payTime',
        // },
        // {
        //     title: '备注',
        //     width: 160,
        //     dataIndex: 'note',
        //     render: text => <p className="ellipsis" title={text}>{text}</p>
        // },
        //  {
        //     title: '系统编号',
        //     width: 160,
        //     dataIndex: 'code',
        //     render: t => t === "listTotalAmount" ? "" : t
        // },
         {
            title: '创建人',
            width: 100,
            dataIndex: 'createUser',
        }, {
            title: '创建时间',
            width: 180,
            dataIndex: 'createTime',
            render: t => momentFormat(t, "YYYY-MM-DD")
        }
    ];


    //点击行选高亮
    const onRow = (code: string) => {
        if (code === "listTotalAmount") return;
        let findIndex = selectedRowKeys.indexOf(code);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(code);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    const totalRow = {
        code: "listTotalAmount",
        totalTxt: "合计:",
        id: "",
        typeNum: dataSource.reduce((con, next) => { con = con + +(next?.typeNum ?? 0); return con }, 0),
        amountTotal: dataSource.reduce((con, next) => { con = con + +(next?.amountTotal ?? 0); return con }, 0),
    }

    useEffect(() => {
        console.log(dataSource.length > 0 ? [...dataSource, totalRow] : [])
    }, [dataSource])

    return (
        <> <Table
            rowKey={record => record.code}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                getCheckboxProps: (record) => {
                    let checkboxProps: any = {};
                    if (record.code === "listTotalAmount") {
                        checkboxProps.disabled = true;
                    }
                    return checkboxProps;
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.code).filter(item => item !== "listTotalAmount");
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.code),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            // dataSource={dataSource}
            dataSource={dataSource.length > 0 ? [...dataSource, totalRow] : []}
            // pagination={{
            //     ...pgCfg,
            //     position: ["bottomCenter"],
            //     showTotal: () => `共${pgCfg.total}条`,
            //     onChange: (pageNum, pageSize) => {
            //         loadData({ pageNum, pageSize })
            //     }
            // }}
            pagination={false}
            onRow={record => ({
                onClick: () => onRow(record.code),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.code]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
            <div style={{
                margin: "5px",
                display: "flex",
                justifyContent: "center"
            }}>
                {dataSource.length > 0 ? <Pagination  {...{
                    ...pgCfg,
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    }
                }} /> : <></>}
            </div>
        </>

    )
}
